<template>
  <!-- 直播页面 -->

  <div>
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <Search />
            <div class="lives">
              <!-- 顶部搜索框 -->
              <mt-navbar v-model="selectedBar" @input="getCurrentSelect">
                <mt-tab-item id="2">热门收藏</mt-tab-item>
                <mt-tab-item id="3">热门直播</mt-tab-item>
              </mt-navbar>
              <!-- 直播列表 -->
              <div class="info">
                <live-info-item
                  v-for="(item, index) in dataForm.liveList"
                  :key="index"
                  :liveCoverImg="item.liveCoverImg"
                  :liveAmt="item.liveAmt"
                  :liveLecturers="item.liveLecturers"
                  :liveName="item.liveName"
                  :liveId="item.liveId"
                  :livePay="item.livePay"
                  :liveStatus="item.liveStatus + ''"
                  :total="item.total"
                  :status="selectedBar"
                  :liveStartTime="item.liveStartTime"
                  :liveEndTime="item.liveEndTime"
                  :liveAttr="item.liveAttr"
                ></live-info-item>
                <div
                  v-if="pageIndex < dataForm.totalPage"
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                  @click="loadMore"
                >
                  点击加载更多...
                </div>
                <div
                  v-else
                  style="
                    text-align: center;
                    font-size: 12px;
                    color: #666;
                    margin-top: 10px;
                  "
                >
                  暂无更多直播...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
import MtTabbar from '../../components/Tabbar'
import LiveInfoItem from '../../components/live/LiveInfoItem'
import Search from '../../components/Search'
import { mapState } from 'vuex'
export default {
  beforeRouteLeave(to, from, next) {
    if (to.fullPath.indexOf('/details?liveId=') == -1) {
      this.$store.commit('changeSelectedHot', '2')
    } else {
      this.$store.commit('changeSelectedHot', this.selectedBar)
    }
    next()
  },
  components: { Search, MtTabbar, LiveInfoItem },
  data() {
    return {
      selectedBar: '2',
      dataForm: {
        currPage: 0,
        liveList: [],
        pageSize: 0,
        totalCount: 0,
        totalPage: 0,
      },
      pageIndex: 1,
      busy: false,
    }
  },
  computed: {
    ...mapState(['selectedHot']),
  },
  methods: {
    refresh() {
      location.reload()
    },
    getCurrentSelect() {
      this.$store.commit('changeSelectedHot', this.selectedBar)
    },
    // 加载更多
    loadMore() {
      this.pageIndex++
      if (this.pageIndex <= this.dataForm.totalPage) {
        this.getLiveList(this.selectedBar, this.pageIndex)
      }
    },

    getLiveList(selectedBar, page) {
      this.$http({
        url: '/live/live/queryCollectionOrGiveLives',
        method: 'get',
        params: {
          status: selectedBar,
          pageNo: page,
          pageSize: 10,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.dataForm.liveList = this.dataForm.liveList.concat(data.data.list)
          this.dataForm.pageSize = data.data.pageSize
          this.dataForm.totalCount = data.data.totalCount
          this.dataForm.totalPage = data.data.totalPage
          this.dataForm.currPage = data.data.currPage
        } else {
          this.dataForm.liveList = []
          this.pageIndex = 1
        }
      })
      this.busy = false
    },
  },
  mounted() {
    let selectedHot = localStorage.getItem('selectedHot')
    selectedHot ? (this.selectedBar = selectedHot) : (this.selectedBar = '2')
    this.pageIndex = 1
    if (selectedHot == '2') {
      this.getLiveList(this.selectedBar, this.pageIndex)
    }
  },
  watch: {
    selectedBar(value) {
      this.dataForm.liveList = []
      this.pageIndex = 1
      this.selectedBar = value

      // localStorage.setItem('selectedBar', value)
      this.getLiveList(value, this.pageIndex)
    },
  },
}
</script>

<style lang='scss' scoped>
.mint-navbar .mint-tab-item {
  padding-top: 5px;
}
.noCourse {
  text-align: center;
  padding: 20px 0;
  color: #666;
  font-size: 14px;
}
.lives {
  padding: 0 1rem;
  p {
    margin: 2rem 0;
    padding: 2rem 0;
    font-size: $font-title;
    border-bottom: 3px solid $theme-color;
  }
}
.info {
  margin-bottom: 6rem;
}
</style>
